import { createSlice } from '@reduxjs/toolkit';
import absWebService from 'app/services/absWebService';
import i18next from 'i18next';

export const submitCompany = ({ company }) => async dispatch => {
	return absWebService
		.getCompanyInfosAndPubKey(company)
		.then(returncontent => {
			var errormessage = "", errormessagetype = "alert";
			if(returncontent.companyshortname != null)
			{
				//set companycookie
				absWebService.setCompanyCookie(returncontent.companyshortname);
				
			  	//when real name is available
				if(returncontent.companyrealname != null)
			 		return dispatch(companychooseSuccess(returncontent.companyrealname));
				else
					return dispatch(companychooseSuccess(returncontent.companyshortname));
			}
			else if(returncontent === "nodata")
			{
				errormessage = i18next.t("loginpage:NOCOMPANYFOUND");
				errormessagetype = "company";
			}
			else
			{
				//only fallback
				errormessage = i18next.t("abswebservice:UNKNOWNERROR")
			}

			const response = [];
			response.push({
				type: errormessagetype,
				message: errormessage
			});

			return dispatch(companychooseError(response));
		})
		.catch(error => {
			if(error == null)
			{
				error = i18next.t("abswebservice:UNKNOWNERROR");
			}

			const response = [];
			response.push({
				type: 'alert',
				message: error
			});

			return dispatch(companychooseError(response));
		});
};

export const checkCompanyCookie = () => async dispatch => {
	var companycookie = absWebService.getCompanyCookie();

	if(companycookie) {
		var companyshortname = companycookie;
		dispatch(submitCompany({company: companyshortname}));
	}
	else
	{
		dispatch(checkCompanyCookieDone());
	}
};

export const removeCompanyCookie = () => dispatch => {
	absWebService.removeCompanyCookie();
};

export const submitPasswordLogin = ({ username, password, keeplogin }) => async dispatch => {
	return absWebService
		.signInWithUsernameAndPassword(username, password, keeplogin)
		.then(user => {

			 // No need to do anything, user data will be set at app/auth/AuthContext

			return dispatch(loginSuccess());
		})
		.catch(error => {
			const response = [];
			response.push({
				type: 'alert',
				message: error
			});
			
			return dispatch(loginError(response));
		});
};

export const submitNFCLogin = ({ chiptext, serialnumber, emulate = false }) => async dispatch => {
	return absWebService
		.signInWithNFCChip(chiptext, serialnumber, emulate)
		.then(user => {

			 // else No need to do anything, user data will be set at app/auth/AuthContext

			//if chipinfo then give back the user
			if(emulate)
				return dispatch(loginSuccess(user));
			else
				return dispatch(loginSuccess());
		})
		.catch(error => {
			const response = [];
			response.push({
				type: 'alert',
				message: error
			});
			
			return dispatch(loginError(response));
		});
};

export const submitForgotPassword = ({ username }) => async dispatch => {
	//first check if session needs to be created
	if(!absWebService.isSessionValid())
	{
		var sessionresp_ = await absWebService.createSession()
		.catch(error => {	
			return error;
		});	
		var sessionresp = await sessionresp_;
		
		if(!absWebService.isResponseArrSuccess(sessionresp))
		{
			return dispatch(forgotPasswordError(absWebService.getDisplayTextFromResponseArr(sessionresp)));
		}
	}

	//then go on
	var serverresp_ = await absWebService.communicationHandler("request_password_reset", {"username":username})
	.catch(error => {
		//give back error for processing below
		return error;
	});
	//await catch error or server response
	const serverresp = await serverresp_;

	if(absWebService.isResponseArrSuccess(serverresp))
	{			
		//success
		return dispatch(forgotPasswordSuccess());
	}
	else
	{
		const response = [];
		response.push({
			type: 'alert',
			message: absWebService.getDataFromResponseArr(serverresp)
		});
		
		return dispatch(forgotPasswordError(response));
	}
};

export const checkPasswortResetData = ({ username, key }) => async dispatch => {
	//first check if session needs to be created
	if(!absWebService.isSessionValid())
	{
		var sessionresp_ = await absWebService.createSession()
		.catch(error => {	
			return error;
		});	
		var sessionresp = await sessionresp_;
		
		if(!absWebService.isResponseArrSuccess(sessionresp))
		{
			return dispatch(forgotPasswordError(absWebService.getDisplayTextFromResponseArr(sessionresp)));
		}
	}

	//then go on
	var serverresp_ = await absWebService.communicationHandler("check_password_reset_data_valid", {"username":username, "key":key})
	.catch(error => {
		//give back error for processing below
		return error;
	});
	//await catch error or server response
	const serverresp = await serverresp_;

	if(absWebService.isResponseArrSuccess(serverresp))
	{
		//success
		return dispatch(resetPasswordCheckSuccess());
	}
	else
	{
		const response = [];
		response.push({
			type: 'alert',
			message: absWebService.getDataFromResponseArr(serverresp)
		});
		
		return dispatch(resetPasswordCheckError(response));
	}
};

export const submitResetPassword = ( {username, key, password} ) => async dispatch => {

	var passwordhash = await absWebService.generatePasswordHash(password);

	var serverresp_ = await absWebService.communicationHandler("finish_password_reset", {"username":username, "key":key, "password_hash_sha512":passwordhash})
	.catch(error => {
		//give back error for processing below
		return error;
	});
	//await catch error or server response
	const serverresp = await serverresp_;

	if(absWebService.isResponseArrSuccess(serverresp))
	{
		//success
		return dispatch(resetPasswordExecSuccess());
	}
	else
	{
		const response = [];
		response.push({
			type: 'alert',
			message: absWebService.getDataFromResponseArr(serverresp)
		});
		
		return dispatch(resetPasswordExecError(response));
	}
};

export const submitChangePassword = ( {username, old_password, new_password} ) => async dispatch => {

	//generate old hash
	var old_passwordhash = await absWebService.generatePasswordHash(old_password);
	//generate new hash
	var new_passwordhash = await absWebService.generatePasswordHash(new_password);

	var serverresp_ = await absWebService.communicationHandler("change_password", {"username":username, "pwdold_sha512":old_passwordhash, "pwdnew_sha512":new_passwordhash})
	.catch(error => {
		//give back error for processing below
		return error;
	});
	//await catch error or server response
	const serverresp = await serverresp_;

	if(absWebService.isResponseArrSuccess(serverresp))
	{
		//success
		return dispatch(resetPasswordExecSuccess());
	}
	else
	{
		const response = [];
		response.push({
			type: 'alert',
			message: absWebService.getDataFromResponseArr(serverresp)
		});
		
		return dispatch(resetPasswordExecError(response));
	}
};

//this is for switching between login and forgotpassword, so that no old error gets shown
export const resetLogin = () => dispatch => {
	return dispatch(resetLoginDis());
}

const initialState = {
	type: null,
	success: false,
	errors: []
};

const loginSlice = createSlice({
	name: 'login',
	initialState,
	reducers: {
		resetLoginDis: (state, action) => {
			state.type = initialState.type,
			state.success = initialState.success,
			state.errors= initialState.errors
		},
		companychooseSuccess: (state, action) => {
			state.type = 'company';
			state.success = true;
			state.companyname = action.payload;
			state.errors = [];
		},
		companychooseError: (state, action) => {
			state.type = 'company';
			state.success = false;
			state.companyname = "";
			state.errors = action.payload;
			//absWebService.removeCompanyCookie();
		},
		checkCompanyCookieDone: (state, action) => {
			state.type = 'company';
			state.success = false;
			state.companyname = "";
			state.errors = null;
		},
		loginSuccess: (state, action) => {
			state.type = 'user';
			state.success = true;
			state.errors = [];
		},
		loginError: (state, action) => {
			state.type = 'user';
			state.success = false;
			state.errors = action.payload;
		},
		forgotPasswordSuccess: (state, action) => {
			state.type = 'forgotpw';
			state.success = true;
			state.errors = [];
		},
		forgotPasswordError: (state, action) => {
			state.type = 'forgotpw';
			state.success = false;
			state.errors = action.payload;
		},
		resetPasswordCheckSuccess: (state, action) => {
			state.type = 'resetpwcheck';
			state.success = true;
			state.errors = [];
		},
		resetPasswordCheckError: (state, action) => {
			state.type = 'resetpwcheck';
			state.success = false;
			state.errors = action.payload;
		},
		resetPasswordExecSuccess: (state, action) => {
			state.type = 'resetpwexec';
			state.success = true;
			state.errors = [];
		},
		resetPasswordExecError: (state, action) => {
			state.type = 'resetpwexec';
			state.success = false;
			state.errors = action.payload;
		},
	},
	extraReducers: {}
});

export const { resetLoginDis, companychooseSuccess, companychooseError, checkCompanyCookieDone, loginSuccess, loginError, forgotPasswordSuccess, forgotPasswordError, resetPasswordCheckSuccess, resetPasswordCheckError, resetPasswordExecSuccess, resetPasswordExecError } = loginSlice.actions;

export default loginSlice.reducer;
